// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-insurance/component/copay-blacklist/copay-blacklist.less
// module id = 3196
// module chunks = 0